import styled, { css } from "styled-components";

const positionStyles = {
  bottomRight: css`
    right: 1.5rem;
    bottom: 1.5rem;
    top: auto;
    transform: none;
  `,
  centerRight: css`
    right: 1.5rem;
    top: 50%;
    bottom: auto;
    transform: translateY(-50%);
  `,
};

const sizeStyles = {
  md: css`
    padding: 0.6rem 1rem;
    font-size: 0.95rem;
  `,
  lg: css`
    padding: 0.85rem 1.25rem;
    font-size: 1.05rem;
  `,
};

export const FloatingButton = styled.button`
  /* base */
  position: fixed;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  z-index: 1100;
  cursor: pointer;
  user-select: none;
  line-height: 1;
  border: none;
  outline: none;
  text-decoration: none;

  /* look */
  background: var(--bSecondary, #22C993); /* fallback color; override with CSS variable or props */
  color: white;
  box-shadow: 0 6px 18px rgba(12, 32, 80, 0.16);
  transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease;

  /* rounded by default */
  border-radius: ${(p) => (p.round ? "999px" : "8px")};

  /* default variant props */
  ${(p) => sizeStyles[p.size || "lg"]}

  /* position variants */
  ${(p) => positionStyles[p.position || "bottomRight"]}

  /* hover / focus */
  &:hover {
    transform: translateY(-3px) scale(1.01);
  }
  &:active {
    transform: translateY(0) scale(0.995);
  }
  &:focus {
    box-shadow: 0 0 0 4px rgba(0,112,243,0.14);
  }

  /* accessible hidden on very small screens if needed */
  @media (max-width: 420px) {
    right: 0.8rem;
    bottom: 0.8rem;
    ${(p) => (p.size === "md" ? "" : "padding: 0.6rem 0.9rem;")}
  }
`;

/* usage example (named export default optional) */
export default FloatingButton;
